var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FCDDD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3894 21.3047C32.406 21.5033 33.4151 21.9521 34.1474 22.6853C34.8798 23.4186 35.3281 24.4289 35.5264 25.4467M32.0789 16.4724C34.1909 16.7073 36.0914 17.7303 37.5949 19.2337C39.0984 20.7372 40.1155 22.6421 40.3528 24.7563M40.352 35.079V38.8203C40.3579 40.2504 39.0735 41.4447 37.6313 41.3144C25.1841 41.3242 15.5312 31.5698 15.541 19.1912C15.4111 17.755 16.598 16.4739 18.0246 16.4725H21.7687C22.3744 16.4666 22.9616 16.6809 23.4208 17.0755C24.7265 18.1975 25.5663 22.0058 25.2431 23.5196C24.9909 24.7016 23.8009 25.5285 22.9918 26.337C24.7685 29.4591 27.3555 32.0442 30.48 33.8195C31.2891 33.011 32.1167 31.8219 33.2995 31.5698C34.8169 31.2465 38.645 32.0885 39.7611 33.4048C40.1569 33.8716 40.3672 34.4674 40.352 35.079Z",
    stroke: "#F8AA9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.682a67e38a587707a96813b0115b0adb.svg";
export { ForwardRef as ReactComponent };